export default {
  button: {
    add: '添加',
    edit: '修改',
    delete: '删除',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    cancel: '取消',
    clear: '清除',
    back: '返回',
    export: '导出',
    lang:'中文'
  },
  navbar :{
    profile : '个人信息',
    logOut: '退出登录',
    updatePwd: '修改密码'
  }
}




// WEBPACK FOOTER //
// ./src/lang/zh.js